// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"loginForm_loginForm__2MSgb"};